import { 
    Create, 
    SimpleForm, 
    TextInput, 
    required 
  } from "react-admin";
  import { FileInput } from "../fileinputs/eventFileUpload";
  import { MyRichTextInput } from "./utils";
  
  export function AchievementCreate(props) {
      return (
          <Create {...props}>
              <SimpleForm>
                  <TextInput source="name" validate={required()} />
                  <MyRichTextInput source="description" />
                  <FileInput source="images" add edit />
              </SimpleForm>
          </Create>
      );
  }